import React from "react";
import AllIssuesPage from "./components/AllIssuesPage";
import About from "./components/About";
import { Switch, Route } from "react-router-dom";
import "./App.css";
import AddIssue from "./components/AddIssue";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "./actions/IssueActions";
import * as UserActions from "./actions/UserActions";
import Header from "./components/Header";
import Welcome from "./components/Welcome";
import Signup from "./components/Signup";
import UserProfile from "./components/UserProfile";

const App = (props) => {
  
  return (
    <div style={{width: "100%"}}>
      <Header />
      <Switch>
        <Route path="/issue-tracker/" exact>
          <Welcome />
        </Route>
        <Route path="/issue-tracker/signup">
          <Signup />
        </Route>
        <Route path="/issue-tracker/about">
          <About />
        </Route>
        <Route path="/issue-tracker/issues">
          <AllIssuesPage />
        </Route>
        <Route path="/issue-tracker/addIssue">
          <AddIssue />
        </Route>
        <Route path="/issue-tracker/profile">
          <UserProfile />
        </Route>
      </Switch>
    </div>
  );
};

function mapStateToProps(state) {
  //console.log("[App] ", state);
  return {
    issues: state.issues,
    users: state.users
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
